"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const nav = [
  { href: "/", label: "Overview" },
  { href: "/health", label: "Health" },
  { href: "/deploy", label: "Deploy" },
];

export function DashboardShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  return (
    <div className="flex min-h-full flex-1">
      <aside className="hidden w-56 shrink-0 flex-col border-r border-panel-border bg-panel/60 px-4 py-6 sm:flex">
        <div className="mb-8 px-2">
          <p className="font-mono text-[10px] tracking-[0.2em] text-accent uppercase">
            Coolify
          </p>
          <p className="mt-1 text-sm font-semibold text-foreground">
            Preview Test
          </p>
        </div>
        <nav className="flex flex-col gap-1">
          {nav.map((item) => {
            const active =
              item.href === "/"
                ? pathname === "/"
                : pathname.startsWith(item.href);
            return (
              <Link
                key={item.href}
                href={item.href}
                className={`rounded-md px-3 py-2 text-sm transition-colors ${
                  active
                    ? "bg-accent-dim/40 text-accent"
                    : "text-muted hover:bg-panel-border/40 hover:text-foreground"
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>
        <p className="mt-auto px-2 font-mono text-[10px] text-muted">
          dashboard · v3
        </p>
      </aside>

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex items-center justify-between border-b border-panel-border px-4 py-3 sm:px-8">
          <nav className="flex gap-1 sm:hidden">
            {nav.map((item) => {
              const active =
                item.href === "/"
                  ? pathname === "/"
                  : pathname.startsWith(item.href);
              return (
                <Link
                  key={item.href}
                  href={item.href}
                  className={`rounded-md px-2.5 py-1.5 text-xs ${
                    active ? "bg-accent-dim/40 text-accent" : "text-muted"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>
          <p className="hidden font-mono text-xs text-muted sm:block">
            Self-hosted Coolify preview probe
          </p>
          <span className="rounded-md border border-panel-border px-2 py-1 font-mono text-[10px] text-muted">
            live
          </span>
        </header>
        <div className="flex flex-1 flex-col px-4 py-8 sm:px-8">{children}</div>
      </div>
    </div>
  );
}
